import { cn } from "@omni/utils/styles";

type Props = {
    src: string;
    alt: string;
    className?: string;
};

export const Icon = ({ src, alt, className }: Props) => {
    return (
        <img
            className={cn("tw:h-8", className)}
            src={src}
            alt={alt}
        />
    );
};
